module.exports = __webpack_public_path__ + "static/media/AiAnimation.ec922507.webp";